module.exports = __webpack_public_path__ + "static/media/orange_theater.bb78c43f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/orange_theater.png
// module id = 747
// module chunks = 0